import { 
    ColumnOrderState,
    VisibilityState,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable 
} from '@tanstack/react-table'

import React, { useEffect, useState } from 'react'
import TanstackTable from '../../../../common/table/TanstackTable'
import GroupDashboardCardFooter from '../../GroupDashboardFooter'
import ReportingFilters from '../ReportingFilters/ReportingFilters'
import Loader from '../../../../common/loader/Loader'
import Notice from '../../../../common/card/Notice'
import MemberHeader from '../../Members/Header/MemberHeader'

const TanstackContent = ({
    data,
    columns,
    rowSelection,
    setRowSelection,
    sorting,
    setSorting,
    globalFilter,
    setGlobalFilter,
    filterType='full-filter',
    exportHeaders,
    from='Course Report',
    context='Courses',
    children,
    hideFilters=false,
    columnFilters,
    setColumnFilters,
    renderSubComponent
}) => {

    const [ isLoading, setIsLoading ] = useState(true)
    const colIndex = columns.length === 2 ? 1 : 0 // 0 if we don't need checkbox
    const [columnOrder, setColumnOrder] = React.useState<ColumnOrderState>(
        columns[ colIndex ].columns.map((column) => column.id as string)
    )
  
    if(!columnOrder.includes('select')) columnOrder.unshift('select')
    
    const hiddenColumn = Object.fromEntries(
        columns[ colIndex ].columns
        .filter(column => column.show === false)
        .map(column => [column.accessorKey,false])
    )
      
    const [columnVisibility, setColumnVisibility] = React.useState<VisibilityState>( hiddenColumn )

    const table = useReactTable({
        data,
        columns,
        state: {
            columnVisibility,
            rowSelection,
            sorting,
            globalFilter,
            columnOrder,
            columnFilters,
        },
        enableHiding: true,
        enableRowSelection: true, //enable row selection for all rows
        enableColumnFilters: true, // enable filter for all columns
        onRowSelectionChange: setRowSelection,
        onGlobalFilterChange: setGlobalFilter,
        onSortingChange: setSorting,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onColumnFiltersChange: setColumnFilters,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
        getRowCanExpand: (row) => true
    })

    useEffect(() => {
      setTimeout(() => {
        if( data && table ){
          setIsLoading(false)
        }
      }, 1000);
    }, [])

    const membersFrom = [ 'Members Table', 'Pending Invites Table' ]
    const membersContext = [ 'Members', 'Pending Invites' ]

    const fallbackMessage = () => {
      switch ( true ) {
        case ( from === membersFrom[0] && context === membersContext[0] ):
          return ( <strong> No { context.toLocaleLowerCase() } added yet</strong> )
        case ( from === membersFrom[1] && context === membersContext[1] ):
          return ( <strong> No { context } </strong> )
        default:
          return ( <strong>No { from.toLocaleLowerCase() } in this group</strong> )
      }
    }

    return (
      <div className="msync-reporting__detail__data">
        {
          isLoading
          ? <Loader type='spinner-dual-ring'/>
          : <>
              { !hideFilters && (
                <ReportingFilters
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  setSorting={setSorting}
                  table={table}
                  columnOrder={columnOrder}
                  setColumnOrder={setColumnOrder}
                  selectedLength={Object.keys(rowSelection).length}
                  rowSelection={rowSelection}
                  data={data}
                  exportHeaders={exportHeaders}
                  columnVisibility={columnVisibility}
                  filterType={filterType}
                  from={from}
                  context={context}
                />
              )}
              {
                membersFrom.includes( from ) && membersContext.includes( context ) &&
                <MemberHeader
                  from={from}
                  tableData={data}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  selectedLength={Object.keys(rowSelection).length}
                  rowSelection={rowSelection}
                  setColumnFilters={ setColumnFilters }
                />
              }
              {
                data && data.length !== 0
                ? <>
                    <div className="msync-table__body">
                      <TanstackTable table={table} from={from} renderSubComponent={(row)  => renderSubComponent(row)} />
                    </div>
                    <GroupDashboardCardFooter data={ table } />
                  </>
                : <Notice className="msync-table__notice">
                    { fallbackMessage() }
                  </Notice>
              }
              { children }
            </>
        }
      </div>
    )

}

export default TanstackContent
